import React, { useState, useContext } from 'react';
import { Input, InputNumber, Form, Button, Row, Col, Collapse, Card, Space, Popconfirm, message, Select, ConfigProvider, Modal } from 'antd';
import { FileOutlined, CheckCircleOutlined, WarningOutlined, LineHeightOutlined, PoweroffOutlined } from '@ant-design/icons';
import AppLayout from "./components/AdminLayout";
import { LanguageContext } from "./LanguageContext";
import CollapsePanel from 'antd/es/collapse/CollapsePanel';

const importAllIcons = (requireContext) => {
    let icons = {};
    requireContext.keys().forEach((key) => {
      const match = key.match(/\.\/(\d+)\.svg$/);
      if (match) {
        const iconKey = match[1];
        const importedIcon = requireContext(key);
        // Eğer modül default olarak export edilmişse onu, aksi halde direkt modülü alıyoruz.
        icons[iconKey] = importedIcon.default || importedIcon;
      }
    });
    return icons;
  };
  const icons = importAllIcons(require.context('./ikonlar', false, /\.svg$/));

const EditableJson = () => {
  const [iconModalVisible, setIconModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentOutputIndex, setCurrentOutputIndex] = useState(null);
  const [currentInputIndex, setCurrentInputIndex] = useState(null);
  const [currentVoltageIndex, setCurrentVoltageIndex] = useState(null);
  const [currentFloatIndex, setCurrentFloatIndex] = useState(null);
  const [currentTempratureIndex, setCurrentTempratureIndex] = useState(null); 
  const { language, translations } = useContext(LanguageContext);
  const [configName, setConfigName] = useState('');

  

  const handleIconSelect = (iconNumber) => {
    if (currentOutputIndex !== null) {
      const updatedOutputs = [...outputs];
      updatedOutputs[currentOutputIndex].icon = iconNumber;
      setOutputs(updatedOutputs);
      setIconModalVisible(false);
      setCurrentOutputIndex(null);
    };
    if(currentTempratureIndex !== null) {
      const updatedTempratures = [...tempratures];
      updatedTempratures[currentTempratureIndex].icon = iconNumber;
      setTempratures(updatedTempratures);
      setIconModalVisible(false);
      setCurrentTempratureIndex(null);
    }
    if (currentFloatIndex !== null) {
        const updatedFloats = [...floats];
        updatedFloats[currentFloatIndex].icon = iconNumber;
        setFloats(updatedFloats);
        setIconModalVisible(false);
        setCurrentFloatIndex(null);
    };
    if (currentVoltageIndex !== null) {
        const updatedVoltages = [...voltages];
        updatedVoltages[currentVoltageIndex].icon = iconNumber;
        setVoltages(updatedVoltages);
        setIconModalVisible(false);
        setCurrentVoltageIndex(null);
    };
    if (currentInputIndex !== null) {
        const updatedInputs = [...inputs];
        updatedInputs[currentInputIndex].icon = iconNumber;
        setInputs(updatedInputs);
        setIconModalVisible(false);
        setCurrentInputIndex(null);
    };
  };

  const [selectedIcon, setSelectedIcon] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const handleMouseEnter = (icon) => {
    setHoveredIcon(icon);
  };

  const handleMouseLeave = () => {
    setHoveredIcon(null);
  };

  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const [formValues, setFormValues] = useState({
    first_row_capacity: 4,
    second_row_capacity: 4
  });

  // Karanlık mod açma-kapama fonksiyonu
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Karanlık mod için Ant Design tema ayarları
  const darkTheme = {
    token: {
      colorBgBase: '#141414', // Temel arka plan rengi
      colorTextBase: '#ffffff', // Metin rengi
      colorLink: '#1890ff', // Link rengi
      colorPrimary: '#1890ff', // Birincil renk
    },
  };

  const allFloatsPins = ["B6", "B7", "C1", "C2", "C3"];
  const allSocketPins = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
         "B1", "B8",
         "C6", "C7", "C8",
         "D0", "D1", "D2"];
  const allInputPins = ["B4", "B3", "B2", "B1"];
  const allVoltagesPins = ["00",
         "C1", "C2", "C3", "C4"];

  const allOutputPins = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
         "B1", "B8",
         "C6", "C7", "C8",
         "D0", "D1", "D2"];


  
  
  const [outputs, setOutputs] = useState([
    {
      socketpin: "",
      type: "enabled",
      currentlimit: 10000,
      currentgreenlimit: 90,
      page: 1,
      row: 2,
      column: 1,
      icon: 1,
      nameTR: "Buzdolabı",
      nameGB: "Fridge",
      nameDE: "Kühlschrank",
      cloneActive: false, 
    }
  ]);

  const handleCloneOutput = (index) => {
    const updatedOutputs = [...outputs];
    if (!updatedOutputs[index].cloneActive) {
      updatedOutputs[index].cloneActive = true;
      updatedOutputs[index].page2 = updatedOutputs[index].page + 1; // Örneğin mevcut sayfaya göre
      updatedOutputs[index].row2 = updatedOutputs[index].row;
      updatedOutputs[index].column2 = updatedOutputs[index].column;
    }
    setOutputs(updatedOutputs);
  };

  const handleRemoveCloneOutput = (index) => {
    const updatedOutputs = [...outputs];
    if (updatedOutputs[index].cloneActive) {
      updatedOutputs[index].cloneActive = false;
      delete updatedOutputs[index].page2;
      delete updatedOutputs[index].row2;
      delete updatedOutputs[index].column2;
    }
    setOutputs(updatedOutputs);
  };
  
  const [tempratures, setTempratures] = useState([
    {
      no : 1,
      enable : "true",
      icon : 44,
      side : "left"
    },
    {
      no : 2,
      enable : "true",
      icon : 43,
      side : "right"
    },
  ]);

  const handleAddTemrature = () =>{
    const newTemprature = {
      no : 1,
      enable : "true",
      icon : 44,
      side : "left"
    };
    setTempratures([...tempratures, newTemprature]);
  };

  const handleAddOutput = () => {
    const newOutput = {
      socketpin: "",
      type: "enabled",
      currentlimit: 10000,
      currentgreenlimit: 90,
      nameTR: "Yeni Çıkış TR",
      nameGB: "New Output GB",
      nameDE: "Neuer Ausgang DE"
    };
    setOutputs([...outputs, newOutput]);
  };

  const handleDeleteOutput = (index) => {
    const newOutputs = [...outputs];
    newOutputs.splice(index, 1);
    setOutputs(newOutputs);
  };

  const handleAddFloat =() =>{
    const newFloat ={
      socketpin: "",
      enable: "true",
      type: "",
      purpose: "",
      warn_percent: 20,
      error_percent: 0,
      lock_pin: "",
      page: 1,
      row: 1,
      column: 3,
      icon: 0,
      nameTR: "Temiz Su",
      nameGB: "Clean Water",
      nameDE: "Sauberes Wasser"
    };
    setFloats([...floats, newFloat])
  }

  const [floats, setFloats] = useState([
    {
      socketpin: "B6",
      enable: "true",
      type: "0-190",
      purpose: "water",
      warn_percent: 20,
      error_percent: 0,
      lock_pin: "",
      page: 1,
      row: 1,
      column: 3,
      icon: 0,
      nameTR: "Temiz Su",
      nameGB: "Clean Water",
      nameDE: "Sauberes Wasser",
      cloneActive: false,
    }
  ]);

  const handleCloneFloat = (index) => {
    const updatedFloats = [...floats];
    if (!updatedFloats[index].cloneActive) {
      updatedFloats[index].cloneActive = true;
      updatedFloats[index].page2 = updatedFloats[index].page + 1; // Örneğin mevcut sayfaya göre
      updatedFloats[index].row2 = updatedFloats[index].row;
      updatedFloats[index].column2 = updatedFloats[index].column;
    }
    setFloats(updatedFloats);
  };

  const handleRemoveCloneFloat = (index) => {
    const updatedFloats = [...floats];
    if (updatedFloats[index].cloneActive) {
      updatedFloats[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedFloats[index].page2;
      delete updatedFloats[index].row2;
      delete updatedFloats[index].column2;
    }
    setFloats(updatedFloats);
  };


  const handleAddVoltage =() =>{
    const newVoltage ={
      socketpin : "",
      enable : "true",
      icon: 30,
      nameTR: "Servis Aküsü",
      nameGB: "Servicebatterie",
      nameDE: "Servicebatterie"
    };
    setVoltages([...voltages, newVoltage])
  }

  const handleDeleteFloat =(index) => {
    const newFloats = [...floats];
    newFloats.splice(index,1);
    setFloats(newFloats);
  };

  const [voltages, setVoltages] = useState([
    {
      socketpin: "00",
      enable: "true",
      page: 1,
      row: 1,
      column: 1,
      icon: 30,
      nameTR: "Servis Aküsü",
      nameGB: "Servicebatterie",
      nameDE: "Servicebatterie",
      cloneActive: false,
    }
  ]);

  const handleCloneVoltage = (index) => {
    const updatedVoltages = [...voltages];
    if (!updatedVoltages[index].cloneActive) {
      updatedVoltages[index].cloneActive = true;
      updatedVoltages[index].page2 = updatedVoltages[index].page + 1; // Örneğin mevcut sayfaya göre
      updatedVoltages[index].row2 = updatedVoltages[index].row;
      updatedVoltages[index].column2 = updatedVoltages[index].column;
    }
    setVoltages(updatedVoltages);
  };

  const handleRemoveCloneVoltage = (index) => {
    const updatedVoltages = [...voltages];
    if (updatedVoltages[index].cloneActive) {
      updatedVoltages[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedVoltages[index].page2;
      delete updatedVoltages[index].row2;
      delete updatedVoltages[index].column2;
    }
    setVoltages(updatedVoltages);
  };

  const handleDeleteVoltages =(index) => {
    const newVoltages = [...inputs];
    newVoltages.splice(index,1);
    setVoltages(newVoltages);
  };

  const handleAddRelay =() => {
    const newRelay ={
      enable: "true",
      short_circuit_socketpin: "C6",
      open_circuit_socketpin: "B8",
      short_circuit_voltage: 13200,
      open_circuit_voltage: 12500,
      manualoverride_duration: 75
    };
    setRelays([...relays, newRelay]);
  };

  const [relays, setRelays] = useState([
    {
      enable: "",
      short_circuit_socketpin: "",
      open_circuit_socketpin: "",
      short_circuit_voltage: 13200,
      open_circuit_voltage: 12500,
      manualoverride_duration: 75
    }
  ]);

  const handleAddSettings =() => {
    const newSetting ={
      force_shut_down_voltage: 10500,
      optional_down_voltage: 11000,
      start_warn_voltage: 11500,
      recover_voltage: 12000,
      force_shut_down_time: 60
    };
    setSettings([...settings, newSetting]);
  };

  const [settings, setSettings] = useState([
    {
      force_shut_down_voltage: 10500,
      optional_down_voltage: 11000,
      start_warn_voltage: 11500,
      recover_voltage: 12000,
      force_shut_down_time: 60
    }
  ]);

  const handleAddInput =() => {
    const newInput ={
      socketpin: "",
      enable: "true",
      vavienoutput: "",
      icon: 6,
      nameTR: "Dış Aydınlatma",
      nameGB: "Outdoor Lighting",
      nameDE: "Außenbeleuchtung"
    };
    setInputs([...inputs, newInput]);
  };

  const [inputs, setInputs] = useState([
    {
      socketpin: "",
      enable: "true",
      vavienoutput: "",
      icon: 6,
      nameTR: "Dış Aydınlatma",
      nameGB: "Outdoor Lighting",
      nameDE: "Außenbeleuchtung",
      cloneActive: false,
    }
  ]);

    const getPageData = (pageNo) => {
  return pages.find(p => p.no === pageNo);
  };

  const handleCloneInput = (index) => {
    const updatedInputs = [...inputs];
    if (!updatedInputs[index].cloneActive) {
      updatedInputs[index].cloneActive = true;
      updatedInputs[index].page2 = updatedInputs[index].page + 1; // Örneğin mevcut sayfaya göre
      updatedInputs[index].row2 = updatedInputs[index].row;
      updatedInputs[index].column2 = updatedInputs[index].column;
    }
    setInputs(updatedInputs);
  };

  const handleRemoveCloneInput = (index) => {
    const updatedInputs = [...inputs];
    if (updatedInputs[index].cloneActive) {
      updatedInputs[index].cloneActive = false;
      // Klon alanlarını silmek için:
      delete updatedInputs[index].page2;
      delete updatedInputs[index].row2;
      delete updatedInputs[index].column2;
    }
    setInputs(updatedInputs);
  };

  const handleDeleteInput =(index) => {
    const newInputs = [...inputs];
    newInputs.splice(index,1);
    setInputs(newInputs);
  };

  const [pages, setPages] = useState([
    { no: 1, first_row_capacity: 4, second_row_capacity: 4, name: "-" },
    { no: 2, first_row_capacity: 4, second_row_capacity: 4, name: "-" },
    { no: 3, first_row_capacity: 4, second_row_capacity: 3, name: "-" }
  ]);
  

  const handleChange = (index, field, value, setState, state, isPageField = false) => {
    if (field === 'page' && !isPageField) {
      const maxPage = pages.length;
      if (value > maxPage) {
        message.error(`Sayfa numarası maksimum sayfa sayısını aşamaz (${maxPage}).`);
        return;
      }
    }
  
    // Değeri integer olup olmadığını kontrol et
    const parsedValue = /^\d+$/.test(value) ? parseInt(value, 10) : value;
  
    const updatedState = [...state];
    updatedState[index][field] = parsedValue; // Integer ise number, değilse string olarak kaydet
    setState(updatedState);
  };
  
  const handleAddPage = () => {
    if (pages.length >= 10) {
      message.warning('Maksimum 10 sayfa eklenebilir.');
      return;
    }
    
    // Burada formdaki input değerlerini alıyoruz (örneğin state ile)
    const firstRowCapacity = formValues.first_row_capacity;
    const secondRowCapacity = formValues.second_row_capacity;
  
    const newPage = {
      no: pages.length + 1,
      first_row_capacity: firstRowCapacity,
      second_row_capacity: secondRowCapacity
    };
  
    setPages([...pages, newPage]);
  };
  

  const handleDeletePage = (index) => {
    const newPages = [...pages];
    newPages.splice(index, 1); // Sayfayı sil
  
    // Sayfa numaralarını güncelle
    const renumberedPages = newPages.map((page, idx) => ({
      ...page,
      no: idx + 1, // Yeni numaraları sıfırdan başlayarak ayarla
    }));
  
    setPages(renumberedPages); // Yeni listeyi kaydet
  };
  

  const translateText = async (text, from, to) => {
    // Çeviri API'sine istek at
    const response = await fetch(
      `https://api.mymemory.translated.net/get?q=${text}&langpair=${from}|${to}`
    );
    const data = await response.json();
    return data.responseData.translatedText;
  };

  const handleVoltageChangeForFloat = async (index, field, value) => {
    // Türkçe (TR) alanına yazılan değeri güncelle
    setFloats((prev) => {
      const uptadeFloats = [...prev];
      uptadeFloats[index][field] = value;

      if (field === 'nameTR') {
        // Türkçe alanı güncellerken İngilizce ve Almanca çevirilerini yap
        const enTranslation = translateText(value, 'tr', 'en');
        const deTranslation = translateText(value, 'tr', 'de');

        enTranslation.then((en) => {
          deTranslation.then((de) => {
            uptadeFloats[index].nameGB = en;
            uptadeFloats[index].nameDE = de;
            setFloats(uptadeFloats);
          });
        });
      }

      return uptadeFloats;
    });
  };

  const handleVoltageChangeForInput = async (index, field, value) => {
    // Türkçe (TR) alanına yazılan değeri güncelle
    setVoltages((prev) => {
      const updatedVoltages = [...prev];
      updatedVoltages[index][field] = value;

      if (field === 'nameTR') {
        // Türkçe alanı güncellerken İngilizce ve Almanca çevirilerini yap
        const enTranslation = translateText(value, 'tr', 'en');
        const deTranslation = translateText(value, 'tr', 'de');

        enTranslation.then((en) => {
          deTranslation.then((de) => {
            updatedVoltages[index].nameGB = en;
            updatedVoltages[index].nameDE = de;
            setVoltages(updatedVoltages);
          });
        });
      }

      return updatedVoltages;
    });
  };

  const handleInputChangeForInput = async (index, field, value) => {
    // Türkçe (TR) alanına yazılan değeri güncelle
    setInputs((prev) => {
      const updatedInputs = [...prev];
      updatedInputs[index][field] = value;

      if (field === 'nameTR') {
        // Türkçe alanı güncellerken İngilizce ve Almanca çevirilerini yap
        const enTranslation = translateText(value, 'tr', 'en');
        const deTranslation = translateText(value, 'tr', 'de');

        enTranslation.then((en) => {
          deTranslation.then((de) => {
            updatedInputs[index].nameGB = en;
            updatedInputs[index].nameDE = de;
            setInputs(updatedInputs);
          });
        });
      }

      return updatedInputs;
    });
  };

  let debounceTimer; // Global veya dış scope'ta bir değişken tanımlayın

const handleInputChange = (index, field, value) => {
  // Alanı güncelle
  setOutputs((prev) => {
    const updatedOutputs = [...prev];
    updatedOutputs[index][field] = value;
    return updatedOutputs;
  });

  // Eğer Türkçe alanı değiştiyse, çeviriyi gecikmeli yap
  if (field === 'nameTR') {
    // Daha önceki timer varsa temizle
    clearTimeout(debounceTimer);

    // Yeni bir timer başlat
    debounceTimer = setTimeout(() => {
      // Çeviri işlemleri
      const enTranslation = translateText(value, 'tr', 'en');
      const deTranslation = translateText(value, 'tr', 'de');

      Promise.all([enTranslation, deTranslation]).then(([en, de]) => {
        setOutputs((prev) => {
          const updatedOutputs = [...prev];
          updatedOutputs[index].nameGB = en;
          updatedOutputs[index].nameDE = de;
          return updatedOutputs;
        });
      });
    }, 500); // 500ms bekleme süresi
  }
};


let customerInputValues = {
  companyName: "TestCompany",
  caravanType: "TypeA",
  description: "Test açıklama",
  customerNameSurname: "Ahmet Yılmaz",
  customerPhone: "5551234567",
  customerCountry: "TR"
};

const userId = localStorage.getItem("selectedUserId");


  const handleSaveChanges = () => {
    if (!configName) return;
    const cleanedOutputs = outputs.map(output => {
      const { cloneActive, ...rest } = output;
      if (!cloneActive) {
        // Klon aktif değilse, clone alanlarını da kaldırıyoruz.
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    const cleanedInputs = inputs.map(input => {
      const { cloneActive, ...rest } = input;
      if (!cloneActive) {
        // Klon aktif değilse, clone alanlarını da kaldırıyoruz.
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    const cleanedVoltages = voltages.map(voltage => {
      const { cloneActive, ...rest } = voltage;
      if (!cloneActive) {
        // Klon aktif değilse, clone alanlarını da kaldırıyoruz.
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });

    const cleanedFloats = floats.map(float => {
      const { cloneActive, ...rest } = float;
      if (!cloneActive) {
        // Klon aktif değilse, clone alanlarını da kaldırıyoruz.
        const { page2, row2, column2, ...cleaned } = rest;
        return cleaned;
      }
      return rest;
    });
    
    const existingFloatPins = cleanedFloats.map(float => float.socketpin);
    const missingFloatPins = allFloatsPins.filter(pin => !existingFloatPins.includes(pin));
    const missingFloatData = missingFloatPins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const existingVoltagePins = cleanedVoltages.map(voltage => voltage.socketpin);
    const missingVoltagePins = allVoltagesPins.filter(pin => !existingVoltagePins.includes(pin));
    const missingVoltageData = missingVoltagePins.map(pin =>({
      socketpin: pin,
      enable: "false"
    }));


    const existingInputPins = cleanedInputs.map(input =>input.socketpin);
    const missinInputPins = allInputPins.filter(pin => !existingInputPins.includes(pin));
    const missingInputData = missinInputPins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const existingOutputPins = cleanedOutputs.map(output => output.socketpin);
    const missingOutputPins = allOutputPins.filter(pin => !existingOutputPins.includes(pin));
    const missingOutputData = missingOutputPins.map(pin => ({
      socketpin: pin,
      enable: "false"
    }));

    const updatedOutpus = [...outputs, ...missingOutputData];
    const updateVoltages = [...voltages, ...missingVoltageData];
    const updatedFloats = [...floats, ...missingFloatData];
    const updatedInputs = [...inputs, ...missingInputData];
    const filteredPages = pages.map(({ name, ...rest }) => rest);

    const jsonData = {
      outputs: [...cleanedOutputs, ...missingOutputData],
      pages: filteredPages,
      inputs: [...cleanedInputs, ...missingInputData],
      voltages: [...cleanedVoltages, ...missingInputData],
      floats: [...cleanedFloats, ...missingInputData],
      relays: relays[0], 
      settings: settings[0],
      tempratures : tempratures
    };

    // JSON verisini dosya olarak indir
    const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'config.json'; // Dosya adı
    link.click();

    
    const escapedConfig = JSON.stringify(jsonData); 
    const formData = new FormData();

    formData.append("Config", escapedConfig);
  
    fetch("https://json-configrator-api.root.myoctoopidev.com/Customer/Create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        userId: userId,
        config: JSON.stringify(jsonData), // 👈 DİKKAT: Escape edilmiş string olarak gidiyor
        configName: configName
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Başarılı:", data);
    })
    .catch(error => {
      console.error("Hata:", error);
    });

  };

  const openCustomerModal = () => {
    setIsModalVisible(true);
  };

  // Modal form gönderildiğinde global değişkeni güncelle ve handleSaveChanges’i tetikle
  const handleModalOk = (values) => {
    // Modal ile gelen değerler boş bile olsa customerInputValues güncelleniyor.
    customerInputValues = { ...customerInputValues, ...values };
    setIsModalVisible(false);
    // Form gönderim işlemi sonrasında handleSaveChanges fonksiyonu çağrılıyor.
    handleSaveChanges();
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };
 
  const relaySocketPins = outputs
  .filter((output) => output.type === "relay")
  .map((output) => output.socketpin);

  const handleRelayChange = (index, field, value) => {
    const updatedRelays = [...relays];
    updatedRelays[index][field] = value;
    setRelays(updatedRelays);
  };

  // outputs: state’ten gelen array
   const enabledPins = outputs
  .filter(o => o.type === 'enabled')
  .map(o => o.socketpin)
  .filter(pin => pin); // boş/undefined ise at

  return (
    <AppLayout>
          <ConfigProvider theme={isDarkMode ? darkTheme : undefined}>
          <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '110vh',
      }}
    >
          <div style={{ width: '700px', height: '800px', padding: '8px', fontSize: '10px' }}>
          <Card title={translations[language].layoutTitle} bordered={false}>
            <Form layout="vertical">
              <Collapse defaultActiveKey={['1', '2','3']} accordion>

              {/* Pages Section */}
              <Collapse.Panel header={`${translations[language].pages}`} key="2">
                  {pages.map((page, index) => (
                    <Card
                      key={index}
                      title={`${translations[language].pages} ${page.no}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeletePage(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button
                            type="link"
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item label={translations[language].firstRowCapacity}>
                            <Select
                              value={page.first_row_capacity}
                              onChange={(value) => handleChange(index, 'first_row_capacity', value, setPages, pages, true)}
                              style={{ width: '100%' }}
                            >
                              {[0,1, 2, 3, 4, 5].map((val) => (
                                <Select.Option key={val} value={val}>
                                  {val}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label={translations[language].secondRowCapacity}>
                        <Select
                          value={page.second_row_capacity}
                          onChange={(value) =>
                            handleChange(index, 'second_row_capacity', value, setPages, pages, true)
                          }
                          style={{ width: '100%' }}
                        >
                          {[ -1, 0, 1, 2, 3, 4, 5 ].map((val) => (
                            <Select.Option key={val} value={val}>
                              {val === -1 ? `${translations[language].empty}` : val}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item label={translations[language].pageAlias}>
                            <Input
                              value={page.name}
                              onChange={(e) =>
                                handleChange(index, 'name', e.target.value, setPages, pages, true)
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Button type="dashed" onClick={handleAddPage}>
                  {translations[language].addPage}
                  </Button>
                </Collapse.Panel>
                {/* Outputs Section */}
                <Collapse.Panel header={`${translations[language].outputs}`} key="1">
                  {outputs.map((output, index) => {
                    const pageData = getPageData(output.page) || {};
                    const rowOptions = [1];
                    if (pageData.second_row_capacity > 0) rowOptions.push(2);

                    const columnOptions = (() => {
                      if (output.row === 1) return Array.from({ length: pageData.first_row_capacity }, (_, i) => i + 1);
                      if (output.row === 2) return Array.from({ length: pageData.second_row_capacity }, (_, i) => i + 1);
                      return [];
                    })();

                    return(
                      <Card
                      key={index}
                      title={`${translations[language].outputName} ${index + 1}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteOutput(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button
                            type="link"
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                            <Form.Item label={translations[language].outputPin}>
                            <Select
                              value={output.socketpin}
                              onChange={(value) => handleChange(index, 'socketpin', value, setOutputs, outputs)}
                            >
                              {["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "B1", "B8", "C6", "C7", "C8", "D0", "D1", "D2"].map((pin) => {
                                const isDisabled = outputs.some((o) => o.socketpin === pin); // Pin zaten seçilmişse disabled yap
                                return (
                                  <Select.Option key={pin} value={pin} disabled={isDisabled}>
                                    {pin}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                            </Form.Item>
                          </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].type}>
                          <Select
                            value={output.type}
                            onChange={(value) => handleChange(index, 'type', value, setOutputs, outputs)}
                          >
                            <Select.Option value="disabled">{translations[language].disabled}</Select.Option>
                            <Select.Option value="enabled">{translations[language].enabled}</Select.Option>
                            <Select.Option value="fix">{translations[language].Fix}</Select.Option>
                            <Select.Option value="relay">{translations[language].relay}</Select.Option>
                          </Select>
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item 
                          label={translations[language].currentLimit}
                          name={`currentlimit_${index}`}
                          rules={[
                            {
                              validator: (_, value) => {
                                if (value < 0) {
                                  return Promise.reject(new Error('Negatif değer giremezsiniz'));
                                }
                                return Promise.resolve();
                              }
                            }
                          ]}
                          initialValue={10000}
                          getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                          getValueFromEvent={(value) => {
                            if (typeof value === 'string') {
                              value = value.replace(',', '.');
                            }
                            return parseFloat(value) * 1000;
                          }}
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            style={{ width: '100%' }}
                            stringMode
                            value={output.currentlimit ? output.currentlimit / 1000 : 0}
                            onChange={(value) => {
                              if (typeof value === 'string') {
                                value = value.replace(',', '.');
                              }
                              handleChange(index, 'currentlimit', parseFloat(value) * 1000, setOutputs, outputs);
                            }}
                            parser={(value) => value.replace(',', '.')}
                          />
                        </Form.Item>
                      </Col>
                      </Row>
                      <Row gutter={16}>
                      <Col span={8}>
                      <Form.Item label={translations[language].page}>
                        <Select
                          value={output.page}
                          onChange={(value) => handleChange(index, 'page', value, setOutputs, outputs)}
                          style={{ width: '100%' }}
                        >
                          {pages.map((page) => (
                            <Select.Option key={page.no} value={page.no}>
                              {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                        </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].row}>
                          <Select
                            value={output.row}
                            onChange={(value) => handleChange(index, 'row', value, setOutputs, outputs)}
                            style={{ width: '100%' }}
                          >
                             {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
                          </Select>
                        </Form.Item>
                      </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].column}>
                        <Select
                          value={output.column}
                          onChange={(value) => handleChange(index, 'column', value, setOutputs, outputs)}
                          style={{ width: '100%' }}
                        >
                          {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                        </Select>
                      </Form.Item>  
                      </Col>
                      <Col span={24}>
                              {output.cloneActive ? (
                                  <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneOutput(index)}>
                                    {translations[language].deleteClone}
                                  </Button>
                                ) : (
                                  <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneOutput(index)}>
                                    {translations[language].clone}
                                  </Button>
                                )}
                              </Col>
                              </Row>
                                              {/* Eğer klon seçeneği aktifse, ek seçim alanlarını göster */}
                            {output.cloneActive && (
                              <Row gutter={16} style={{ marginTop: '10px' }}>
                                <Col span={8}>
                                  <Form.Item label={translations[language].page2}>
                                    <Select
                                      value={output.page2}
                                      onChange={(value) => handleChange(index, 'page2', value, setOutputs, outputs)}
                                      style={{ width: '100%' }}
                                    >
                                      {pages.map((page) => (
                                        <Select.Option key={page.no} value={page.no}>
                                          {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                <Form.Item label={translations[language].row2}>
                                    <Select
                                      value={output.row2}
                                      onChange={(value) => handleChange(index, 'row2', value, setOutputs, outputs)}
                                      style={{ width: '100%' }}
                                    >
                                      {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
                                    </Select>
                                  </Form.Item>
                                  
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={translations[language].column2}>
                                    <Select
                                      value={output.column2}
                                      onChange={(value) => handleChange(index, 'column2', value, setOutputs, outputs)}
                                      style={{ width: '100%' }}
                                    >
                                      {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                            )}
                          <Row gutter={16}>
                          <Col span={8}>
                          <Form.Item 
                          label={translations[language].currentGreenLimit}
                          name={`currentgreenlimit_${index}`}
                          rules={[
                            {
                              validator: (_, value) => {
                                if (value < 0) {
                                  return Promise.reject(new Error(translations[language].aylalg));
                                }
                                const currentLimit = outputs[index]?.currentlimit ?? 10000; // default 10000
                                const currentLimitInKilo = currentLimit / 1000;
                                if (value > currentLimitInKilo) {
                                  return Promise.reject(new Error(translations[language].aylalg));
                                }
                                return Promise.resolve();
                              }
                            }
                          ]}
                          initialValue={9}
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            stringMode
                            value={output.currentgreenlimit ?? 100}
                            onChange={(value) => {
                              if (typeof value === 'string') {
                                value = value.replace(',', '.');
                              }
                              const parsedGreen = parseFloat(value);
                              const parsedLimit = output.currentlimit ? output.currentlimit / 1000 : 0;

                              if (parsedGreen > parsedLimit) {
                                message.error('Akım Yeşil Limiti, Akım Limitini geçemez!');
                              }

                              handleChange(index, 'currentgreenlimit', parsedGreen, setOutputs, outputs);
                            }}
                            parser={(value) => value.replace(',', '.')}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].icon}>
                        <Button
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                  setCurrentOutputIndex(index);
                                  setIconModalVisible(true);
                                }}
                              >
                                {/* <img
                                  src={icons[output.icon]}
                                  alt={`icon ${output.icon}`}
                                  style={{ width: '24px', height: '24px', marginRight: '8px' }}
                                /> */}  
                                {output.icon}
                              </Button>
                      </Form.Item>
                      </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameTR}>
                            <Input
                              value={output.nameTR}
                              onChange={(e) => handleInputChange(index, 'nameTR', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameGB}>
                            <Input
                              value={output.nameGB}
                              onChange={(e) => handleInputChange(index, 'nameGB', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameDE}>
                            <Input
                              value={output.nameDE}
                              onChange={(e) => handleInputChange(index, 'nameDE', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    );
                    })}
                  <Button type="dashed" onClick={handleAddOutput} style={{ marginBottom: '20px' }}>
                  {translations[language].addOutput}
                  </Button>
                </Collapse.Panel>
                  {/* Inputs Section */}
                  <Collapse.Panel header={`${translations[language].inputs}`} key="3">
                  {inputs.map((input, index) => {
                    const pageData = getPageData(input.page) || {};
                    const rowOptions = [1];
                    if (pageData.second_row_capacity > 0) rowOptions.push(2);
                    const columnOptions = (() => {
                      if (input.row === 1) return Array.from({ length: pageData.first_row_capacity }, (_, i) => i + 1);
                      if (input.row === 2) return Array.from({ length: pageData.second_row_capacity }, (_, i) => i + 1);
                      return [];
                    })();
                    return(
                    <Card
                      key={index}
                      title={`${translations[language].inputName} ${index + 1}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteInput(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button 
                            type="link" 
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label={translations[language].inputPin}>
                        <Select
                          value={input.socketpin}
                          onChange={(value) => handleChange(index, 'socketpin', value, setInputs, inputs)}
                        >
                          {['B4', 'B3', 'B2', 'B1'].map((pin) => (
                            <Select.Option 
                              key={pin} 
                              value={pin} 
                              disabled={inputs.some((input) => input.socketpin === pin)}
                            >
                              {pin}
                            </Select.Option>
                          ))}
                        </Select>

                        </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].enable}>
                        <Select
                          value={input.enable}
                          onChange={(value) => handleChange(index, 'enable', value, setInputs, inputs)}
                          style={{ width: '100%' }}
                        >
                          <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                          <Select.Option value={"false"}>{translations[language].no}</Select.Option>
                        </Select>
                      </Form.Item>
                      </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].vavienOutput}>
                          <Select
                            value={input.vavienoutput}
                            onChange={(value) => handleChange(index, 'vavienoutput', value, setInputs, inputs)}
                            style={{ width: '100%' }}
                          >
                            {['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'B1', 'B8', 'C6', 'C7', 'C8', 'D0', 'D1', 'D2'].map((pin) => (
                              <Select.Option 
                                key={pin} 
                                value={pin} 
                                disabled={inputs.some((input) => input.vavienoutput === pin)}
                              >
                                {pin}
                              </Select.Option>
                            ))}
                          </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                      <Col span={8}>
                      <Form.Item label={translations[language].page}>
                    <Select
                      value={input.page}
                      onChange={(value) => handleChange(index, 'page', value, setInputs, inputs)}
                      style={{ width: '100%' }}
                    >
                      {pages.map((page) => (
                        <Select.Option key={page.no} value={page.no}>
                          {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].row}>
                            <Select
                              value={input.row}
                              onChange={(value) => handleChange(index, 'row', value, setInputs, inputs)}
                              style={{ width: '100%' }}
                            >
                              {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
                            </Select>
                          </Form.Item>
                        
                      </Col>
                        
                        <Col span={8}>
                          <Form.Item label={translations[language].column}>
                          <Select
                            value={input.column}
                            onChange={(value) => handleChange(index, 'column', value, setInputs, inputs)}
                            style={{ width: '100%' }}
                          >
                            {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                          </Select>
                        </Form.Item>
                        </Col>
                      </Row>
                      {input.cloneActive && (
                      <Row gutter={16} style={{ marginTop: '10px' }}>
                        <Col span={8}>
                          <Form.Item label={translations[language].page2}>
                            <Select
                              value={input.page2}
                              onChange={(value) => handleChange(index, 'page2', value, setInputs, inputs)}
                              style={{ width: '100%' }}
                            >
                              {pages.map((page) => (
                                <Select.Option key={page.no} value={page.no}>
                                  {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].column2}>
                            <Select
                              value={input.column2}
                              onChange={(value) => handleChange(index, 'column2', value, setInputs, inputs)}
                              style={{ width: '100%' }}
                            >
                              {[1, 2, 3, 4, 5].map((val) => (
                                <Select.Option key={val} value={val}>
                                  {val}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].row2}>
                            <Select
                              value={input.row2}
                              onChange={(value) => handleChange(index, 'row2', value, setInputs, inputs)}
                              style={{ width: '100%' }}
                            >
                              <Select.Option value={1}>1</Select.Option>
                              <Select.Option value={2}>2</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                      <Row gutter={16}>
                        <Col span={8}>
                        <Form.Item label={translations[language].icon}>
                        <Button
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                  setCurrentInputIndex(index);
                                  setIconModalVisible(true);
                                }}
                              >
                                {/* <img
                                  src={icons[output.icon]}
                                  alt={`icon ${output.icon}`}
                                  style={{ width: '24px', height: '24px', marginRight: '8px' }}
                                /> */}  
                                {input.icon}
                              </Button>
                      </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameTR}>
                            <Input
                              value={input.nameTR}
                              onChange={(e) => handleInputChangeForInput(index, 'nameTR', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameGB}>
                            <Input
                              value={input.nameGB}
                              onChange={(e) => handleInputChangeForInput(index, 'nameGB', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameDE}>
                            <Input
                              value={input.nameDE}
                              onChange={(e) => handleInputChangeForInput(index, 'nameDE', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>);
                    
                    })}
                  <Button type="dashed" onClick={handleAddInput} style={{ marginBottom: '20px' }}>
                  {translations[language].addInput}
                  </Button>
                </Collapse.Panel>
                  {/* Voltage Section */}
                  <Collapse.Panel header={`${translations[language].voltages}`} key="4">
                  {voltages.map((voltage, index) => {
                    const pageData = getPageData(voltage.page) || {};
                    const rowOptions = [1];
                    if (pageData.second_row_capacity > 0) rowOptions.push(2);

                    const columnOptions = (() => {
                      if (voltage.row === 1) return Array.from({ length: pageData.first_row_capacity }, (_, i) => i + 1);
                      if (voltage.row === 2) return Array.from({ length: pageData.second_row_capacity }, (_, i) => i + 1);
                      return [];
                    })();

                  return(
                    <Card
                      key={index}
                      title={`${translations[language].voltageName} ${index + 1}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteVoltages(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button 
                            type="link" 
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label={translations[language].voltagesPin}>
                        <Select
                          value={voltage.socketpin}
                          onChange={(value) => handleChange(index, 'socketpin', value, setVoltages, voltages)}
                          style={{ width: '100%' }}
                        >
                          {['00', 'C1', 'C2', 'C3', 'C4'].map((pin) => (
                            <Select.Option 
                              key={pin} 
                              value={pin} 
                              disabled={voltages.some((voltage) => voltage.socketpin === pin)}
                            >
                              {pin}
                            </Select.Option>
                          ))}
                        </Select>

                        </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].enable}>
                        <Select
                          value={voltage.enable}
                          onChange={(value) => handleChange(index, 'enable', value, setVoltages, voltages)}
                          style={{ width: '100%' }}
                        >
                          <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                          <Select.Option value={"false"}>{translations[language].no}</Select.Option>
                        </Select>
                      </Form.Item>

                      </Col>
                      </Row>
                      <Row gutter={16}>
                      <Col span={8}>
                      <Form.Item label={translations[language].page}>
                      <Select
                        value={voltage.page}
                        onChange={(value) => handleChange(index, 'page', value, setVoltages, voltages)}
                        style={{ width: '100%' }}
                      >
                        {pages.map((page) => (
                          <Select.Option key={page.no} value={page.no}>
                            {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                        </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].row}>
                          <Select
                            value={voltage.row}
                            onChange={(value) => handleChange(index, 'row', value, setVoltages, voltages)}
                            style={{ width: '100%' }}
                          >
{rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
                          </Select>
                        </Form.Item>
                      
                    </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].column}>
                        <Select
                          value={voltage.column}
                          onChange={(value) => handleChange(index, 'column', value, setVoltages, voltages)}
                          style={{ width: '100%' }}
                        >
{columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                        </Select>
                      </Form.Item>
                      </Col>
                      <Col span={24}>
                      {voltage.cloneActive ? (
                          <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneVoltage(index)}>
                            {translations[language].deleteClone}
                          </Button>
                        ) : (
                          <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneVoltage(index)}>
                            {translations[language].clone}
                          </Button>
                        )}
                      </Col>
                                      </Row>
                                      {voltage.cloneActive && (
                      <Row gutter={16} style={{ marginTop: '10px' }}>
                        <Col span={8}>
                          <Form.Item label={translations[language].page2}>
                            <Select
                              value={voltage.page2}
                              onChange={(value) => handleChange(index, 'page2', value, setVoltages, voltages)}
                              style={{ width: '100%' }}
                            >
                              {pages.map((page) => (
                                <Select.Option key={page.no} value={page.no}>
                                  {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].row2}>
                            <Select
                              value={voltage.row2}
                              onChange={(value) => handleChange(index, 'row2', value, setVoltages, voltages)}
                              style={{ width: '100%' }}
                            >
                              {rowOptions.map(r => (
                              <Select.Option key={r} value={r}>{r}</Select.Option>
                            ))}
                            </Select>
                          </Form.Item>
                          
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].column2}>
                            <Select
                              value={voltage.column2}
                              onChange={(value) => handleChange(index, 'column2', value, setVoltages, voltages)}
                              style={{ width: '100%' }}
                            >
                              {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    )}

                      <Row gutter={16}>
                      
                        <Col span={8}>
                        <Form.Item label={translations[language].icon}>
                        <Button
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                  setCurrentVoltageIndex(index);
                                  setIconModalVisible(true);
                                }}
                              >
                                {/* <img
                                  src={icons[output.icon]}
                                  alt={`icon ${output.icon}`}
                                  style={{ width: '24px', height: '24px', marginRight: '8px' }}
                                /> */}  
                                {voltage.icon}
                              </Button>
                      </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameTR}>
                            <Input
                              value={voltage.nameTR}
                              onChange={(e) => handleVoltageChangeForInput(index, 'nameTR', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameGB}>
                            <Input
                              value={voltage.nameGB}
                              onChange={(e) => handleVoltageChangeForInput(index, 'nameGB', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameDE}>
                            <Input
                              value={voltage.nameDE}
                              onChange={(e) => handleVoltageChangeForInput(index, 'nameDE', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>);
                    
                    })}
                  <Button type="dashed" onClick={handleAddVoltage} style={{ marginBottom: '20px' }}>
                  {translations[language].addVoltage}
                  </Button>
                  </Collapse.Panel>
                  {/* floats Section */}
                  <Collapse.Panel header={`${translations[language].floats}`} key="5">
                  {floats.map((float, index) => {
                    
                    const pageData = getPageData(float.page) || {};
                    const rowOptions = [1];
                    if (pageData.second_row_capacity > 0) rowOptions.push(2);

                    const columnOptions = (() => {
                      if (float.row === 1) return Array.from({ length: pageData.first_row_capacity }, (_, i) => i + 1);
                      if (float.row === 2) return Array.from({ length: pageData.second_row_capacity }, (_, i) => i + 1);
                      return [];
                    })();
                    return(
                    <Card
                      key={index}
                      title={`${translations[language].floatName} ${index + 1}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteFloat(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                          <Button 
                            type="link" 
                            danger
                            style={{ fontWeight: 'bold', color: '#ff4d4f', padding: '0 10px' }}
                          >
                            {translations[language].delete}
                          </Button>
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label={translations[language].floatsPin}>
                        <Select
                          value={float.socketpin}
                          onChange={(value) => handleChange(index, 'socketpin', value, setFloats, floats)}
                          style={{ width: '100%' }}
                        >
                          {['B6', 'B7', 'C1', 'C2', 'C3'].map((pin) => (
                            <Select.Option
                              key={pin}
                              value={pin}
                              disabled={floats.some((float) => float.socketpin === pin)}
                            >
                              {pin}
                            </Select.Option>
                          ))}
                        </Select>

                        </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].enable}>
                        <Select
                          value={float.enable}
                          onChange={(value) => handleChange(index, 'enable', value, setFloats, floats)}
                          style={{ width: '100%' }}
                        >
                          <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                          <Select.Option value={"false"}>{translations[language].no}</Select.Option>
                        </Select>
                      </Form.Item>

                      </Col>
                      <Col span={8}>
                        <Form.Item label={translations[language].type}>
                          <Select
                            value={float.type}
                            onChange={(value) => handleChange(index, 'type', value, setFloats, floats)}
                            style={{ width: '100%' }}
                          >
                            <Select.Option value="0-190">0-190</Select.Option>
                            <Select.Option value="240-33">240-33</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={translations[language].purpose}>
                          <Select
                            value={float.purpose}
                            onChange={(value) => handleChange(index, 'purpose', value, setFloats, floats)}
                            style={{ width: '100%' }}
                          >
                            <Select.Option value="water">{translations[language].water}</Select.Option>
                            <Select.Option value="drain">{translations[language].drain}</Select.Option>
                            <Select.Option value="gray">{translations[language].gray}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item 
                      label={translations[language].warnPercent}
                      name={`warn_percent_${index}`}
                      rules={[
                        {
                          validator: (_, value) => {
                            const errorValue = floats[index]?.error_percent ?? 0;
                            const purpose = floats[index]?.purpose;

                            if (value < 0) {
                              return Promise.reject(new Error(translations[language].negatifdg));
                            }

                            if (purpose === 'water' && value <= errorValue) {
                              return Promise.reject(new Error(translations[language].tsuiuy));
                            }

                            if ((purpose === 'drain' || purpose === 'gray') && value >= errorValue) {
                              return Promise.reject(new Error(translations[language].kgsiu));
                            }

                            return Promise.resolve();
                          }
                        }
                      ]}
                      initialValue={20}
                    >
                      <InputNumber
                        min={0}
                        defaultValue={20}
                        value={float.warn_percent ?? 20}
                        onChange={(value) => handleChange(index, 'warn_percent', value, setFloats, floats)}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item 
                      label={translations[language].errorPercent}
                      name={`error_percent_${index}`}
                      rules={[
                        {
                          validator: (_, value) => {
                            const warnValue = floats[index]?.warn_percent ?? 0;
                            const purpose = floats[index]?.purpose;

                            if (value < 0) {
                              return Promise.reject(new Error(translations[language].negatifdg));
                            }

                            if (purpose === 'water' && warnValue <= value) {
                              return Promise.reject(new Error(translations[language].tsuiuy));
                            }

                            if ((purpose === 'drain' || purpose === 'gray') && warnValue >= value) {
                              return Promise.reject(new Error(translations[language].kgsiu));
                            }

                            return Promise.resolve();
                          }
                        }
                      ]}
                      initialValue={0}
                    >
                      <InputNumber
                        min={0}
                        defaultValue={0}
                        value={float.error_percent ?? 0}
                        onChange={(value) => handleChange(index, 'error_percent', value, setFloats, floats)}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                    </Col>
                        <Col span={8}>

                        {floats.map((float, idx) => (
                    <Form.Item label={translations[language].lock_pin}>
                          <Select
                            value={float.lock_pin}
                            onChange={val => handleChange(idx, 'lock_pin', val, setFloats, floats)}
                            style={{ width: '100%' }}
                            placeholder={translations[language].selectLockPin}
                          >
                            <Select.Option value="">{translations[language].empty}</Select.Option>
                            {enabledPins.map(pin => (
                              <Select.Option
                                key={pin}
                                value={pin}
                                disabled={floats.some(f => f.lock_pin === pin)}
                              >
                                {pin}
                              </Select.Option>
                            ))}
                          </Select>
                      </Form.Item>
                                ))}
                        </Col>
                      </Row>
                      <Row gutter={16}>
                      <Col span={8}>
                      <Form.Item label={translations[language].page}>
                      <Select
                        value={float.page}
                        onChange={(value) => handleChange(index, 'page', value, setFloats, floats)}
                        style={{ width: '100%' }}
                      >
                        {pages.map((page) => (
                          <Select.Option key={page.no} value={page.no}>
                            {`${translations[language].page} ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                        </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].row}>
                          <Select
                            value={float.row}
                            onChange={(value) => handleChange(index, 'row', value, setFloats, floats)}
                            style={{ width: '100%' }}
                          >
                          {rowOptions.map(r => (
                            <Select.Option key={r} value={r}>{r}</Select.Option>
                          ))}
                          </Select>
                        </Form.Item>
                        
                      </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].column}>
                          <Select
                            value={float.column}
                            onChange={(value) => handleChange(index, 'column', value, setFloats, floats)}
                            style={{ width: '100%' }}
                          >
                            {columnOptions.map(c => (
                            <Select.Option key={c} value={c}>{c}</Select.Option>
                          ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                      {float.cloneActive ? (
                          <Button type="default" style={{ width: '100%' }} onClick={() => handleRemoveCloneFloat(index)}>
                            {translations[language].deleteClone} 
                          </Button>
                        ) : (
                          <Button type="default" style={{ width: '100%' }} onClick={() => handleCloneFloat(index)}>
                            {translations[language].clone}
                          </Button>
                        )}
                      </Col>
                      </Row>
                      {float.cloneActive && (
                      <Row gutter={16} style={{ marginTop: '10px' }}>
                        <Col span={8}>
                          <Form.Item label={translations[language].page2}>
                            <Select
                              value={float.page2}
                              onChange={(value) => handleChange(index, 'page2', value, setFloats, floats)}
                              style={{ width: '100%' }}
                            >
                              {pages.map((page) => (
                                <Select.Option key={page.no} value={page.no}>
                                  {`Sayfa ${page.no} ${page.name ? `- ${page.name}` : ''}`}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].row2}>
                            <Select
                              value={float.row2}
                              onChange={(value) => handleChange(index, 'row2', value, setFloats, floats)}
                              style={{ width: '100%' }}
                            >
                              {rowOptions.map(r => (
                  <Select.Option key={r} value={r}>{r}</Select.Option>
                ))}
                            </Select>
                          </Form.Item>
                          
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].column2}>
                            <Select
                              value={float.column2}
                              onChange={(value) => handleChange(index, 'column2', value, setFloats, floats)}
                              style={{ width: '100%' }}
                            >
                              {columnOptions.map(c => (
                  <Select.Option key={c} value={c}>{c}</Select.Option>
                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                      <Row gutter={16}>
                        <Col span={8}>
                        <Form.Item label={translations[language].icon}>
                        <Button
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                  setCurrentFloatIndex(index);
                                  setIconModalVisible(true);
                                }}
                              >
                                {/* <img
                                  src={icons[output.icon]}
                                  alt={`icon ${output.icon}`}
                                  style={{ width: '24px', height: '24px', marginRight: '8px' }}
                                /> */}  
                                {float.icon}
                              </Button>
                      </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameTR}>
                            <Input
                              value={float.nameTR}
                              onChange={(e) => handleVoltageChangeForFloat(index, 'nameTR', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameGB}>
                            <Input
                              value={float.nameGB}
                              onChange={(e) => handleVoltageChangeForFloat(index, 'nameGB', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label={translations[language].nameDE}>
                            <Input
                              value={float.nameDE}
                              onChange={(e) => handleVoltageChangeForFloat(index, 'nameDE', e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    );
                   })}
                  <Button type="dashed" onClick={handleAddFloat} style={{ marginBottom: '20px' }}>
                  {translations[language].addFloat}
                  </Button>
                  </Collapse.Panel>
                  {/* relay Section */}
                  <Collapse.Panel header={`${translations[language].relay}`} key="6">
                  {relays.map((relay, index) => (
                    <Card
                      key={index}
                      title={`${translations[language].relay}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteFloat(index)}
                          okText={translations[language].yes}
                          
                          cancelText={translations[language].yes}
                        >
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                      <Form.Item label={translations[language].active}>
                        <Select
                          value={relay.enable}
                          onChange={(value) => handleChange(index, 'enable', value, setRelays, relays)}
                          disabled={relaySocketPins.length <= 1}
                          style={{ width: '100%' }}
                        >
                          <Select.Option value={"true"}>{translations[language].yes}</Select.Option>
                          <Select.Option value={"false"}>{translations[language].no}</Select.Option>
                        </Select>
                      </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].shortCircuitSocketpin}>
                      <Select
                        value={relay.short_circuit_socketpin}
                        onChange={(value) => handleRelayChange(index, 'short_circuit_socketpin', value)}
                        disabled={relaySocketPins.length <= 1} // Eğer 2 veya daha azsa devre dışı
                      >
                        {relaySocketPins.map((pin) => (
                          <Select.Option key={pin} value={pin}>
                            {pin}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                      </Col>
                      <Col span={8}>
                      <Form.Item label={translations[language].openCircuitSocketpin}>
                      <Select
                        value={relay.open_circuit_socketpin}
                        onChange={(value) => handleRelayChange(index, 'open_circuit_socketpin', value)}
                        disabled={relaySocketPins.length <= 1}
                      >
                        {relaySocketPins.map((pin) => (
                          <Select.Option key={pin} value={pin}>
                            {pin}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                        </Col>
                        <Col span={8}>
                      <Form.Item 
                      label={translations[language].shortCircuitVoltage}
                      name={`short_circuit_voltage_${index}`}
                      // rules={[
                      //   {
                      //     validator: (_, value) => {
                      //       if (value < 13200) {
                      //         return Promise.reject(new Error('13200\'den küçük değer giremezsiniz'));
                      //       }
                      //       return Promise.resolve();
                      //     }
                      //   }
                      // ]}
                      initialValue={13200}
                      getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                      getValueFromEvent={(value) => {
                        if (typeof value === 'string') {
                          value = value.replace(',', '.');
                        }
                        return parseFloat(value) * 1000;
                      }}
                    >
                      <InputNumber
                        min={8}
                        max={100}
                        style={{ width: '100%' }}
                        stringMode
                        disabled={relaySocketPins.length <= 1}
                        value={relay.short_circuit_voltage ? relay.short_circuit_voltage / 1000 : 13.2}
                        onChange={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          handleChange(index, 'short_circuit_voltage', parseFloat(value) * 1000, setRelays, relays);
                        }}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item 
                      label={translations[language].openCircuitVoltage}
                      name={`open_circuit_voltage_${index}`}
                      // rules={[
                      //   {
                      //     validator: (_, value) => {
                      //       if (value < 13200) {
                      //         return Promise.reject(new Error('13200\'den küçük değer giremezsiniz'));
                      //       }
                      //       return Promise.resolve();
                      //     }
                      //   }
                      // ]}
                      initialValue={12500}
                      getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                      getValueFromEvent={(value) => {
                        if (typeof value === 'string') {
                          value = value.replace(',', '.');
                        }
                        return parseFloat(value) * 1000;
                      }}
                    >
                      <InputNumber
                        min={8}
                        max={100}
                        style={{ width: '100%' }}
                        stringMode
                        disabled={relaySocketPins.length <= 1}
                        value={relay.open_circuit_voltage ? relay.open_circuit_voltage / 1000 : 12.5}
                        onChange={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          handleChange(index, 'open_circuit_voltage', parseFloat(value) * 1000, setRelays, relays);
                        }}
                        parser={(value) => value.replace(',', '.')}
                      />
                    </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label={translations[language].manualOverrideDuration}>
                      <Input
                        type="number"
                        min="0"
                        max="86400"
                        value={relay.manualoverride_duration}
                        disabled={relaySocketPins.length <= 1}
                        onChange={(e) => {
                          const value = Math.min(86400, Math.max(0, e.target.value));
                          handleChange(index, 'manualoverride_duration', value, setRelays, relays);
                        }}
                      />
                    </Form.Item>
                    </Col>
                      </Row>
                      
                    </Card>
                  ))}
                  </Collapse.Panel>
                  {/* setting Section */}
                  <Collapse.Panel header={`${translations[language].setting}`} key="7">
                  {settings.map((setting, index) => (
                    <Card
                      key={index}
                      title={`${translations[language].setting}`}
                      bordered
                      style={{ marginBottom: '20px', borderRadius: '8px' }}
                      extra={
                        <Popconfirm
                          title={translations[language].deleteConfirm}
                          onConfirm={() => handleDeleteFloat(index)}
                          okText={translations[language].yes}
                          cancelText={translations[language].no}
                        >
                        </Popconfirm>
                      }
                    >
                      <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                        label={translations[language].forceShutDownVoltage}
                        name={`force_shut_down_voltage_${index}`}
                        rules={[
                          {
                            validator: (_, value) =>
                              value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
                          },
                        ]}
                        initialValue={10500}
                        getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                        getValueFromEvent={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          return parseFloat(value) * 1000;
                        }}
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          style={{ width: '100%' }}
                          stringMode
                          value={setting.force_shut_down_voltage ? setting.force_shut_down_voltage / 1000 : 10.5}
                          onChange={(value) => {
                            if (typeof value === 'string') {
                              value = value.replace(',', '.');
                            }
                            handleChange(index, 'force_shut_down_voltage', parseFloat(value) * 1000, setSettings, settings);
                          }}
                          parser={(value) => value.replace(',', '.')}
                        />
                      </Form.Item>

                      </Col>
                      <Col span={8}>
                        <Form.Item
                        label={translations[language].optionalDownVoltage}
                        name={`optional_down_voltage_${index}`}
                        rules={[
                          {
                            validator: (_, value) =>
                              value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
                          },
                        ]}
                        initialValue={11000}
                        getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                        getValueFromEvent={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          return parseFloat(value) * 1000;
                        }}
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          style={{ width: '100%' }}
                          stringMode
                          value={setting.optional_down_voltage ? setting.optional_down_voltage / 1000 : 11}
                          onChange={(value) => {
                            if (typeof value === 'string') {
                              value = value.replace(',', '.');
                            }
                            handleChange(index, 'optional_down_voltage', parseFloat(value) * 1000, setSettings, settings);
                          }}
                          parser={(value) => value.replace(',', '.')}
                        />
                      </Form.Item>

                      </Col>
                      <Col span={8}>
                        <Form.Item
                        label={translations[language].startWarnVoltage}
                        name={`start_warn_voltage_${index}`}
                        rules={[
                          {
                            validator: (_, value) =>
                              value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
                          },
                        ]}
                        initialValue={11500}
                        getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                        getValueFromEvent={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          return parseFloat(value) * 1000;
                        }}
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          style={{ width: '100%' }}
                          stringMode
                          value={setting.start_warn_voltage ? setting.start_warn_voltage / 1000 : 11.5}
                          onChange={(value) => {
                            if (typeof value === 'string') {
                              value = value.replace(',', '.');
                            }
                            handleChange(index, 'start_warn_voltage', parseFloat(value) * 1000, setSettings, settings);
                          }}
                          parser={(value) => value.replace(',', '.')}
                        />
                      </Form.Item>

                      </Col>
                      <Col span={8}>
                       <Form.Item
                        label={translations[language].recoverVoltage}
                        name={`recover_voltage_${index}`}
                        rules={[
                          {
                            validator: (_, value) =>
                              value < 0 ? Promise.reject(new Error('Negatif değer giremezsiniz')) : Promise.resolve(),
                          },
                        ]}
                        initialValue={12000}
                        getValueProps={(value) => ({ value: value ? value / 1000 : 0 })}
                        getValueFromEvent={(value) => {
                          if (typeof value === 'string') {
                            value = value.replace(',', '.');
                          }
                          return parseFloat(value) * 1000;
                        }}
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          style={{ width: '100%' }}
                          stringMode
                          value={setting.recover_voltage ? setting.recover_voltage / 1000 : 12}
                          onChange={(value) => {
                            if (typeof value === 'string') {
                              value = value.replace(',', '.');
                            }
                            handleChange(index, 'recover_voltage', parseFloat(value) * 1000, setSettings, settings);
                          }}
                          parser={(value) => value.replace(',', '.')}
                        />
                      </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                      label={translations[language].forceShutDownTime}
                      name={`force_shut_down_time_${index}`}
                      rules={[
                        {
                          validator: (_, value) =>
                            value < 0 || value > 600 
                              ? Promise.reject(new Error('Değer 0-600 arasında olmalıdır')) 
                              : Promise.resolve(),
                        },
                      ]}
                      initialValue={60}
                    >
                      <InputNumber
                        min={0}
                        max={600}  // Maksimum 600 olarak ayarlandı
                        defaultValue={60}
                        value={setting.force_shut_down_time ?? 60}
                        onChange={(value) => handleChange(index, 'force_shut_down_time', value, setSettings, settings)}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                      </Col>
                    </Row>
                    </Card>
                  ))}
                  </Collapse.Panel>
                  {/* Tempratures Section */}
                  <Collapse.Panel header = {translations[language].temprature} key="8">
                  {tempratures.map((temprature, index) =>(
                    <Card title = {`${translations[language].numberOfTemprature} ${temprature.no}`}  >
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label={translations[language].isTempratureEnable}>
                          <Select
                            value={temprature.enable}
                            onChange={(value) => handleChange(index, 'enable', value, setTempratures, tempratures)}
                          >
                            <Select.Option value="true">{translations[language].true}</Select.Option>
                            <Select.Option value="false">{translations[language].false}</Select.Option>
                          </Select>
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].location}>
                          <Select
                            value={temprature.side}
                            onChange={(value) => handleChange(index, 'side', value, setTempratures, tempratures)}
                          >
                            <Select.Option value="right">{translations[language].right}</Select.Option>
                            <Select.Option value="left">{translations[language].left}</Select.Option>
                          </Select>
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item label={translations[language].icon}>
                        <Button
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                  setCurrentTempratureIndex(index);
                                  setIconModalVisible(true);
                                }}
                              >
                                {temprature.icon}
                              </Button>
                      </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  ))}
                  </Collapse.Panel>
              </Collapse>
            </Form>
            <Space style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
        <Input
        placeholder={translations[language].kag}
        value={configName}
        onChange={e => setConfigName(e.target.value)}
        required
        style={{ width: '250px' }}
      />
      <Button
        type="primary"
        onClick={handleSaveChanges}
        disabled={!configName}
      >
        {translations[language].dkvi}
      </Button>
      </Space>
          </Card>
          {/* <Modal
        title={translations[language].customerInformation}
        visible={isModalVisible}
        footer={null}
        onCancel={handleModalCancel}
      >
        <Form
          layout="vertical"
          initialValues={{
            companyName: '',
            caravanType: '',
            description: '',
            customerNameSurname: '',
            customerPhone: '',
            customerCountry: ''
          }}
          onFinish={handleModalOk}
        >
          <Form.Item label={translations[language].companyName} name="companyName">
            <Input placeholder={translations[language].optional}/>
          </Form.Item>
          <Form.Item label={translations[language].caravanType} name="caravanType">
            <Input placeholder={translations[language].optional} />
          </Form.Item>
          <Form.Item label={translations[language].description} name="description">
            <Input.TextArea placeholder={translations[language].optional} />
          </Form.Item>
          <Form.Item label={translations[language].customerNameSurname} name="customerNameSurname">
            <Input placeholder={translations[language].optional} />
          </Form.Item>
          <Form.Item label={translations[language].customerPhone} name="customerPhone">
            <Input placeholder={translations[language].optional} />
          </Form.Item>
          <Form.Item label={translations[language].customerCountry} name="customerCountry">
            <Input placeholder={translations[language].optional} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
            {translations[language].dkvi}
            </Button>
          </Form.Item>
        </Form>
      </Modal> */}
        </div>
        </div>
        <Modal
          title={translations[language].selectIcon}
          visible={iconModalVisible}
          onCancel={() => setIconModalVisible(false)}
          footer={null}
          bodyStyle={{ backgroundColor: '#1890ff', padding: '30px', minHeight: '300px', borderRadius: '10px' }}
          width={600}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
            {[...Array(100)].map((_, i) => (
              <div
                key={i}
                onClick={() => handleIconSelect(i)}
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #fff',
                  borderRadius: '10px',
                }}
              >
                <img src={icons[i]} alt={`icon ${i}`} style={{ width: '40px', height: '40px' }} />
              </div>
            ))}
          </div>
        </Modal>
        </ConfigProvider>
    </AppLayout>
  );
};
export default EditableJson;